module.exports = __webpack_public_path__ + "img/twitter.c4431f4d.png";